import { render, staticRenderFns } from "./DialogLinkTable.vue?vue&type=template&id=892c0fc0&scoped=true&"
import script from "./DialogLinkTable.vue?vue&type=script&lang=js&"
export * from "./DialogLinkTable.vue?vue&type=script&lang=js&"
import style0 from "./DialogLinkTable.vue?vue&type=style&index=0&id=892c0fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c0fc0",
  null
  
)

export default component.exports